export default "__VITE_ASSET__s_Kp$gCK__"